<template>
  <div
    class="about-section about-two section-padding white-bg"
    :class="{ 'pt-0': className }"
  >
    <div class="container">
      <div class="row">
        <div
          class="col-xl-6 col-lg-6 col-12 wow fadeInDown animated"
          data-wow-delay="200ms"
        >
          <div class="about-left-wrap">
            <div class="section-title">
              <p>About Afino Tax Consultants</p>
              <h2>Trusted & Results-Driven Tax & Accounting Firm in Dubai</h2>
            </div>
            <div class="fouder-wrap light-bg-2">
              <div class="fouder-thumb">
                <img src="/assets/img/about/founder-thumb.png" alt="" />
              </div>
              <div class="founder-content">
                <div class="founder-title">
                  <h5>Afino Tax Consultants, <span>Dubai, UAE</span></h5>
                </div>
                <p>
                  A trusted and results-driven tax and accounting firm based in Dubai, UAE. 
                  We help businesses stay fully compliant while achieving financial clarity and growth.
                </p>
              </div>
            </div>
            <div
              class="about-left-img wow fadeInUp animated"
              data-wow-delay="400ms"
            >
              <img src="/assets/img/about/about-3.jpg" alt="" />
              <RouterLink :to="{ name: 'About' }">Discover More</RouterLink>
            </div>
          </div>
        </div>
        <div
          class="col-xl-6 col-lg-6 col-12 wow fadeInRight animated"
          data-wow-delay="200ms"
        >
          <div class="about-right-wrap">
            <div class="about-right-img">
              <img src="/assets/img/about/about-4.jpg" alt="" />
            </div>
            <p>
              Our team of qualified professionals combines local expertise with international standards 
              to deliver accurate, transparent, and timely financial support tailored to each client's 
              unique needs. We have earned the trust of clients across multiple industries, from startups 
              and SMEs to established corporations.
            </p>
            <div class="about-feature-list">
              <div class="row">
                <div class="col-md-6 col-12">
                  <ul>
                    <li>
                      <i class="las la-check-circle"></i> Corporate Tax Services
                    </li>
                    <li>
                      <i class="las la-check-circle"></i> VAT Services & Compliance
                    </li>
                  </ul>
                </div>
                <div class="col-md-6 col-12">
                  <ul>
                    <li>
                      <i class="las la-check-circle"></i> Accounting & Bookkeeping
                    </li>
                    <li>
                      <i class="las la-check-circle"></i> Business Advisory Services
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AboutCompany",
  props: ["className"],
};
</script>
